import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import { IconChevronDown, IconChevronRight, IconX } from '@tabler/icons-react';

type Direction = 'down' | 'right';

interface Props {
  direction: Direction;
  onDismiss: () => void;
}

/**
 * Узкая подсказка-плашка с анимированной стрелкой. Занимает место в DOM-flow,
 * чтобы не перекрывать кнопки лайков/коммен.
 *  - direction="down"  → подсказка свайпа вниз (показывается снизу ленты).
 *  - direction="right" → подсказка свайпа вправо (показывается под progress-bar).
 */
export function SwipeHintBar({ direction, onDismiss }: Props) {
  const { t } = useTranslation();
  const Icon = direction === 'down' ? IconChevronDown : IconChevronRight;
  const animate = direction === 'down'
    ? { y: [0, 6, 0] }
    : { x: [0, 6, 0] };
  const text = direction === 'down'
    ? t('feed.hint_swipe_down', { defaultValue: 'Свайп вниз — следующая мысль' })
    : t('feed.hint_swipe_right', { defaultValue: 'Свайп вправо — открыть книгу' });

  return (
    <div className="px-4 pointer-events-none">
      <div className="mx-auto max-w-sm flex items-center gap-2 rounded-pill bg-surface-strong text-text text-xs px-3 py-1.5 shadow-md pointer-events-auto">
        <motion.span
          animate={animate}
          transition={{ duration: 1.1, repeat: Infinity, ease: 'easeInOut' }}
          className="grid place-items-center shrink-0"
        >
          <Icon size={14} strokeWidth={2.5} />
        </motion.span>
        <span className="flex-1 truncate">{text}</span>
        <button
          onClick={onDismiss}
          className="w-5 h-5 grid place-items-center rounded-pill text-text-muted hover:text-text"
          aria-label={t('common.close', { defaultValue: 'Закрыть' })}
        >
          <IconX size={12} />
        </button>
      </div>
    </div>
  );
}
